import {Component, Inject, EventEmitter} from '@angular/core';
import {MAT_DIALOG_DATA} from "@angular/material/dialog";

/**
 * Overlay for showing a single tipp and having arrows left and right to sho the next tipp.
 */
@Component({
    selector: 'smh-tipps-overlay',
    templateUrl: './tipps-overlay.component.html',
    styleUrls: [],
    standalone: false
})
export class TippsOverlayComponent {
  /**
   * Textkey for the main headline
   */
  public headline: string = null;

  /**
   * textkey for the subheadline
   */
  public subheadline: string = null;

  /**
   * textkey of the long description text
   */
  public text: string = null;

  /**
   * textkey for the button, if one exists
   */
  public buttontext: string = null;

  /**
   * URL for the button
   */
  public link: string = null;

  /**
   * image for the background
   */
  public image: string = null;

  /**
   * small description on the right side
   */
  public description: string = null;

  /**
   * Copyright text for the background image
   */
  public copyright: string = null;

  /**
   * placeholder data for the texts
   */
  public placeholder: any;

  /**
   * current tipp index
   */
  public index: number;

  /**
   * eventemitter if the next button is clicked
   */
  public next: EventEmitter<void> = new EventEmitter<void>();

  /**
   * eventemitter if the prev button is clicked
   */
  public prev: EventEmitter<void> = new EventEmitter<void>();

  /**
   * constructore
   * @param data Provide the top headline and the overall count of tipps here.
   */
  constructor(@Inject(MAT_DIALOG_DATA) public data: {headline: any, overall: number}) {
    this.headline = data.headline;
  }

  /**
   * prev link is clicked
   */
  onPrev(): void {
    this.prev.emit();
  }

  /**
   * nextlnk is clicked
   */
  onNext(): void {
    this.next.emit();
  }
}
